export default {
  name: 'BillsListExpand',
  props: {
    data: Object
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'subject', label: this.$t('general.email.title') },
        { key: 'to', label: this.$t('general.email.to'), format: 'formatFunc', funcs: [this.formatReceiver, this.formatReceiverOverwrite], classFuncs: [this.formatReceiverClass, this.formatReceiverOverwriteClass] },
        { key: 'cc', label: this.$t('general.email.cc'), format: 'formatFunc', funcs: [this.formatReceiver, this.formatReceiverOverwrite], classFuncs: [this.formatReceiverClass, this.formatReceiverOverwriteClass] },
        { key: 'bcc', label: this.$t('general.email.bcc'), format: 'formatFunc', funcs: [this.formatReceiver, this.formatReceiverOverwrite], classFuncs: [this.formatReceiverClass, this.formatReceiverOverwriteClass] },
        { key: 'from', label: this.$t('general.email.from') },
        { key: 'sentTimes', label: this.$t('general.email.sentTimes') },
        { key: 'sentTs', label: this.$t('general.email.sentTs'), type: 'datetime' },
        { key: 'errors', label: this.$t('general.email.errors') },
        { key: 'status_id', label: this.$t('general.email.status'), format: 'formatFromConfig', configKey: 'mail_statuses', configParam: 'name' }
      ];
      return headers;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    }
  },
  methods: {
    formatReceiver (value, data) {
      return value;
    },
    formatReceiverOverwrite (value, data) {
      if (data.field.key === 'to') {
        return data.item.receiverOverwrite;
      }
    },
    formatReceiverClass (value, data) {
      if (data.item.receiverOverwrite) {
        return ' text-strikethrough';
      }
    },
    formatReceiverOverwriteClass (value, data) {
      return '';
    }
  }
}
